import { ROLES } from '@whistler-ui/portal/constants/settings';
import { useAuthStore } from '@whistler-ui/portal/store/auth';
import { RoleType } from '@whistler-ui/portal/types/enums';
import { useMemo } from 'react';

const GROUP_ACCESS_ROLES: RoleType[] = [
  ROLES.GROUP_ADMINISTRATOR,
  ROLES.GROUP_USER,
];

export const hasGroupAccess = (roles?: RoleType[]) => {
  if (!roles) {
    return false;
  }

  return roles.some(role => GROUP_ACCESS_ROLES.includes(role));
};

export const useHasGroupAccess = () => {
  const { authValues } = useAuthStore();

  return useMemo(() => {
    return hasGroupAccess(authValues.loggedUser?.roles);
  }, [authValues]);
};
